export default "__VITE_ASSET__C97vGXzn__"